import { createRoot } from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fi as fiLocale } from "date-fns/locale/fi";
import AppCore from "./AppCore";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <CookiesProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fiLocale}>
        <AppCore />
      </LocalizationProvider>
    </CookiesProvider>
  </BrowserRouter>
);
